import { useEffect } from 'react';

import { getQuizQuestions, generateQuizQuestions } from '../../services/ai';

// The server returns `question` / `answer`; the display components downstream
// expect `question1` / `correct_answer1`.
//
// TODO(ai-migration): this rename is now pointless — Course/Quiz.jsx converts
// the fields straight back to `question` / `answer` for its vote, favourite and
// report payloads. It only existed because the old tool-call arguments used
// different names than the API. Removing it means updating ~10 references in
// Course/Quiz.jsx, so it is deliberately left for a follow-up.
function toQuizShape(items) {
    return items.map((item) => ({
        ...item,
        question1: item.question,
        correct_answer1: item.answer,
        answer: undefined,
        question: undefined,
    }));
}

function QuizGenerate({
    chapter,
    course_id,
    setQuiz,
    setActiveComponent,
    loading,
    setLoading,
    setCreateNewQuiz,
    createNewQuiz,
    isMockExam,
    setIsMockExam,
    endOfQuiz,
    setEndOfQuiz,
    mockExam,
    setMockExam,
    mockExamAnswers,
    setMockExamAnswers,
}) {
    const { id: chapter_id, name: chapter_name } = chapter;

    async function createMessage() {
        setActiveComponent('Quiz');
        setQuiz([]);
        setLoading(true);

        try {
            // Existing questions short-circuit generation, which is also what
            // makes a timed-out generation recoverable — the server persists
            // before responding, so a retry reads the rows back.
            const cached = await getQuizQuestions(course_id, chapter_id);
            if (cached.data.length >= 5) {
                generateNewQuiz(toQuizShape(cached.data));
                setLoading(false);
                return;
            }

            const resp = await generateQuizQuestions(course_id, chapter_id);
            generateNewQuiz(toQuizShape(resp.data));
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    }

    function generateNewQuiz(array) {
        setQuiz(array);
        // Mock exam accumulates batches of five. Each call persists its own
        // batch server-side, and the next generation sees the previous
        // questions as dedupe context.
        if (isMockExam) {
            if (mockExam.length === 5) {
                setMockExam((prevMockExam) => [...prevMockExam, ...array]);
                setEndOfQuiz(true);
            } else {
                setMockExam(array);
                setEndOfQuiz(false);
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        if (chapter_name) {
            createMessage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chapter_name]);

    useEffect(() => {
        if (createNewQuiz) {
            if (!isMockExam) {
                createMessage();
            }
            setCreateNewQuiz(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createNewQuiz]);

    return (
        <button
            className="ace__AiGenerate-btn"
            onClick={createMessage}
            disabled={loading}
            style={{ opacity: loading ? 0.5 : 1 }}
        >
            {loading ? 'Loading...' : 'Generate Quiz'}
        </button>
    );
}

export default QuizGenerate;
